module.exports = __webpack_public_path__ + "img/vezapodorysy5NP.08749dd3.png";